import { resolveOwnedInscription } from "./api";
import type { ConnectedWallet, RevealOptions } from "./types";

const INSCRIPTION_ID = /^[0-9a-f]{64}i\d+$/i;

export function normalizeParentIds(primary: string, coParents: string[]): string[] {
  const primaryId = primary.trim();
  const coParentIds = coParents.map((value) => value.trim()).filter(Boolean);
  if (!primaryId && coParentIds.length) throw new Error("Add a primary parent before adding co-parents");
  const ids = [primaryId, ...coParentIds].filter(Boolean);
  const invalid = ids.find((id) => !INSCRIPTION_ID.test(id));
  if (invalid) throw new Error("Enter a valid parent inscription ID");
  if (new Set(ids.map((id) => id.toLowerCase())).size !== ids.length) {
    throw new Error("Each parent inscription can only be added once");
  }
  return ids;
}
export async function resolveParentSelection(connected: ConnectedWallet, primary: string, coParents: string[]): Promise<Pick<RevealOptions, "parent" | "coParents">> {
  const ids = normalizeParentIds(primary, coParents);
  if (!ids.length) return {};
  const [parent, ...resolvedCoParents] = await Promise.all(ids.map(id => resolveOwnedInscription(connected.ordinals.address, id)));
  return { parent, coParents: resolvedCoParents.length ? resolvedCoParents : undefined };
}
